import { CompanyDisplay } from 'components/CompanyDisplay'
import { useCompany } from 'hooks/useCompany'
import { useProjectsForCompany } from 'hooks/useProjectsForCompany'
import React, { FC } from 'react'
import { CompanyIdUrlParam } from 'types'

export const NoCompanyFoundText = 'No Company found!'
export const CompanyView: FC<CompanyIdUrlParam> = ({ companyId }) => {
  const company = useCompany(companyId)
  const projects = useProjectsForCompany((company && company.id) || 0)

  return company ? (
    <CompanyDisplay company={company} projects={projects} />
  ) : (
    <h1>{NoCompanyFoundText}</h1>
  )
}
